export const ErrorMessage = {
  Name: "Name is Mandatory",
  Email: "Email is Mandatory",
  Password: "Password is Mandatory",
  ConfirmPassword: "Confirm Password is Mandatory",
  PhoneNumber: "Phone Number is Mandatory",
  MobileNumber: "Mobile Number is Mandatory",
  UserId: "User Id is Mandatory",
  Captcha: "Captcha is Mandetroy",
  MatchPassword: "password and confirm password not matched",
  ApplicationCategory: "application Category is Mandatory",
  ApplicationSubCategory: "application Sub Category is Mandatory",
  Number: "number is Mandatory",
  Valid: {
    Name: "Name is Invalid",
    Email: "Email is Invalid",
    City: "Village/Town/City is Invalid",
    Area: "Area/Locality/Sector is Invalid",
    Password: "Password is Invalid",
    ConfirmPassword: "Confirm Password is Invalid",
    PhoneNumber: "Phone Number is Invalid",
    MobileNumber: "Mobile Number is Invalid",
    AlternateNumber: "Alternate Number is Invalid",
    UserId: "User Id is Invalid",
    Captcha: "Captcha is Invalid",
    Number: "number is Invalid",
  },
  Invalid: {
    Formate: "Format is not valid"
  }
};
